import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Styles } from '@contently/toolkit';

const Wrapper = styled.p`
  font-size: ${Styles.fonts.sans.size.small};
  font-family: ${Styles.fonts.sans.family};
  color: ${Styles.colors.grey.primary};
  margin-top: 11px;
`;

const Val = styled.span`
  font-weight: ${Styles.fonts.sans.weight.bold};
`;

export default function CharacterLimit({ limit, editorEl }) {
  if (!editorEl.current) return null;

  const characterCount = editorEl.current.innerText.length;

  return (
    <Wrapper>
      Characters: <Val>{characterCount}</Val> / <Val>{limit}</Val>
    </Wrapper>
  );
}

CharacterLimit.propTypes = {
  limit: PropTypes.number.isRequired,
  editorEl: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/CharacterLimit.jsx